import { Flex } from '@grupoboticario/flora-react';

import { ErrorBoundaries } from 'components';
import { FeatureFlag } from 'domains/feature-flag.d';
import { useFeatureFlag, useResellerDetail } from 'hooks';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

import Styles from './CampaignContent.styles';
import { Banner } from '../Banner';
import { Campaign } from '../Campaign';
import { CardInfo } from '../CardInfo';
import { OptInClosed } from '../ClosedOptIn';
import { Confirm } from '../Confirm';
import { Description } from '../Description';
import { OptIn } from '../OptIn';
import { Orders } from '../Orders';
import { Rank } from '../Rank';
import { Reward } from '../Reward';
import { RulesDoubts } from '../RulesDoubts';

export const CampaignContent = () => {
  const { optInData, isError, isLoading, isSuccess, isOptinClosed } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail, isError: isResellerError } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;
  const memberData = optInData?.campaign ?? null;
  const { value: isLoyaltyContentEnabled } = useFeatureFlag(
    FeatureFlag.LOYALTY_INCENTIVE_CAMPAIGN_CONTENT,
    false
  );
  const { value: isLoyaltyRankingEnabled } = useFeatureFlag(
    FeatureFlag.LOYALTY_INCENTIVE_CAMPAIGN_RANKING,
    false
  );
  const { value: isLoyaltyCampaignChallengeEnabled } = useFeatureFlag(
    FeatureFlag.LOYALTY_INCENTIVE_CAMPAIGN_CHALLENGE,
    false
  );

  if (isLoading) return null;

  if (isError || isResellerError) {
    return (
      <ErrorBoundaries.ReloadPage
        title='Tivemos um problema para carregar a página.'
        data-autotagging-flora-section={document}
      />
    );
  }

  const renderToaster = () => {
    if (memberData !== null && !isOptinClosed) {
      return (
        <Styles.ConfirmWrapper>
          <Confirm />
        </Styles.ConfirmWrapper>
      );
    }

    if (isOptinClosed) {
      return <OptInClosed />;
    }

    return null;
  };

  const renderContent = () => {
    if (memberData === null) {
      return (
        <Flex direction='column' gap='$10'>
          <Description />
          <CardInfo />
          <OptIn />
        </Flex>
      );
    }

    if (!isOptinClosed) {
      return (
        <Flex direction='column' gap='$20'>
          {isLoyaltyContentEnabled && isSuccess && (
            <Flex direction='column' gap='$20'>
              {isLoyaltyRankingEnabled && <Rank />}
              <Reward />
              {isLoyaltyCampaignChallengeEnabled && !isLoyaltyMember && <Campaign />}
              <Orders />
            </Flex>
          )}
        </Flex>
      );
    }

    return null;
  };

  return (
    <Styles.Wrapper>
      {renderToaster()}
      <Flex direction='column' gap='$10'>
        <Banner />
        {renderContent()}
        <RulesDoubts />
      </Flex>
    </Styles.Wrapper>
  );
};
